import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { format } from 'prettier';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});
const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IntakeBloodReportPdf = ({ data }) => {
  console.log('IntakeBloodReportPdf', data);
  const user = JSON.parse(localStorage.getItem('user'))
  let totalRecdCash = 0;

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const calculateAge = (dob) => {
    const birthDate = new Date(dob); // Convert the dob string to a Date object
    const today = new Date(); // Get the current date
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    // If the birthday hasn't occurred yet this year, subtract 1 from the age
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    } 
    return age;
};
  
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Bill Register  Report ">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={{...styles.columnHeader, width:'9%'}} content="Sr No." />
              <Text style={{...styles.columnHeader, width:'11%'}} content="Blood Intake No." />
              <Text style={styles.columnHeader} content="Donor Name" />
              <Text style={styles.columnHeader} content="Blood Type" />
              <Text style={styles.columnHeader} content="Component Name" />
              <Text style={styles.columnHeader} content="No. Of Unit" />
              <Text style={styles.columnHeader} content="Blood Group" />
              <Text style={styles.columnHeader} content="Rate" />
              <Text style={styles.columnHeader} content="Amount" />
              <Text style={{...styles.columnHeader, width:'10%'}} content="Status" />

            </View>

            {data &&
              data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={{ ...styles.columnContent, width:'10%' }} content={data?.blood_intake_no} />
                  <Text style={{ ...styles.columnContent, textAlign:'left' }} content={data?.donorMasterData?.patient_name} />
                  {/* <Text
                    style={{ ...styles.columnContent, width: '22%', textAlign:'left' }}
                    content={`${data?.patientData?.name_suffix} ${data?.patientData?.first_name} ${data?.patientData?.last_name}`} /> */}
                  <Text style={styles.columnContent} content={data?.blood_bank_type} />
                  <Text style={{...styles.columnContent, textAlign:'left' }} content={data?.componentData?.component} />
                  <Text style={{...styles.columnContent }} content={data?.blood_items?.[0]?.purchase_details?.quantity} />
                  <Text style={styles.columnContent} content={data?.bloodGroupData?.group} />
                  <Text style={styles.columnContent} content={data?.blood_items?.[0]?.purchase_details?.rate} />
                  <Text style={{...styles.columnContent }} content={data?.bill?.total_amt} />
                  <Text style={{...styles.columnContent, width:'10%'}} content={data?.status} />
                  
                </View>
              ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default IntakeBloodReportPdf;
